import { useReducer } from 'react';
import { initialState, stackModalReducer } from '../context/StackModalReducer';
import { UseStackModalReducerProps } from '../types';
import { useControlModeActions } from './actions/useControlModeActions';
import { useDialogActions } from './actions/useDialogActions';
import { useFieldActions } from './actions/useFieldActions';
import { useFormActions } from './actions/useFormActions';
import { useStackFormActions } from './actions/useStackFormActions';

const useStackModalReducer = ({
  stackId,
  createStack,
  updateStack,
  onClose,
  initialStackName = '',
  initialControlModes = [],
  isDefault,
}: UseStackModalReducerProps) => {
  const [state, dispatch] = useReducer(stackModalReducer, {
    ...initialState,
    stackName: initialStackName,
    controlModes: initialControlModes,
  });

  const formActions = useFormActions(state, dispatch);

  const controlModeActions = useControlModeActions(
    state,
    dispatch,
    formActions.clearControlModeValidationError,
  );

  const fieldActions = useFieldActions(dispatch);

  const dialogActions = useDialogActions(
    state,
    dispatch,
    controlModeActions.handleTemplatesSelected,
  );

  const saveActions = useStackFormActions({
    state,
    dispatch,
    props: {
      stackId,
      createStack,
      updateStack,
      onClose,
      isDefault,
    },
    validateForm: formActions.validateForm,
    showAlert: formActions.showAlert,
  });

  return {
    ...state,
    ...formActions,
    ...controlModeActions,
    ...fieldActions,
    ...dialogActions,
    ...saveActions,
  };
};

export default useStackModalReducer;
